/* global Plotly:true */

import React, { Component } from "react";
import createPlotlyComponent from "react-plotly.js/factory";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getPimaData } from "../../actions/pimadataActions";

const Plot = createPlotlyComponent(Plotly);

class WeeklyAvg extends Component {
  componentDidMount() {
    this.props.getPimaData();
  }
  render() {
    var { pimadatas } = this.props;
    const dataSize = pimadatas.length;
    const greenLimit = [];
    const yellowLimit = [];
    const redLimit = [];
    var avgs = [];
    var avgsText = [];
    for (var i = 0; i < dataSize; i++) {
      if (i % 7 === 0) {
        var sum = 0;
        var divisor = 0;
        if (pimadatas[i] !== undefined) {
          divisor++;
          sum =
            sum +
            parseFloat(pimadatas[i].new_cases_today_pima.replace(/,/g, ""));
        }
        if (pimadatas[i + 1] !== undefined) {
          divisor++;
          sum =
            sum +
            parseFloat(pimadatas[i + 1].new_cases_today_pima.replace(/,/g, ""));
        }
        if (pimadatas[i + 2] !== undefined) {
          divisor++;
          sum =
            sum +
            parseFloat(pimadatas[i + 2].new_cases_today_pima.replace(/,/g, ""));
        }
        if (pimadatas[i + 3] !== undefined) {
          divisor++;
          sum =
            sum +
            parseFloat(pimadatas[i + 3].new_cases_today_pima.replace(/,/g, ""));
        }
        if (pimadatas[i + 4] !== undefined) {
          divisor++;
          sum =
            sum +
            parseFloat(pimadatas[i + 4].new_cases_today_pima.replace(/,/g, ""));
        }
        if (pimadatas[i + 5] !== undefined) {
          divisor++;
          sum =
            sum +
            parseFloat(pimadatas[i + 5].new_cases_today_pima.replace(/,/g, ""));
        }
        if (pimadatas[i + 6] !== undefined) {
          divisor++;
          sum =
            sum +
            parseFloat(pimadatas[i + 6].new_cases_today_pima.replace(/,/g, ""));
        }

        var average = Math.trunc((sum / divisor + Number.EPSILON) * 100) / 100;

        avgs.push(Math.floor(average));
        avgsText.push(
          Math.floor(average)
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
        );
      }
    }

    const weeks = [];
    if (pimadatas.length % 7 === 0) {
      var weeksSize = pimadatas.length / 7;
    } else {
      weeksSize = Math.floor(pimadatas.length / 7) + 1;
    }
    for (var j = 13; j <= weeksSize + 12; j++) {
      weeks.push(j);
    }

    var weeksText = [
      "MAR22 - MAR28",
      "MAR29 - APR04",
      "APR05 - APR11",
      "APR12 - APR18",
      "APR19 - APR25",
      "APR26 - MAY02",
      "MAY03 - MAY09",
      "MAY10 - MAY16",
      "MAY17 - MAY23",
      "MAY24 - MAY30",
      "MAY31 - JUN06",
      "JUN07 - JUN13",
      "JUN14 - JUN20",
      "JUN21 - JUN27",
      "JUN28 - JUL04",
      "JUL05 - JUL11",
      "JUL12 - JUL18",
      "JUL19 - JUL25",
      "JUL26 - AUG01",
      "AUG02 - AUG08",
      "AUG09 - AUG15",
      "AUG16 - AUG22",
      "AUG23 - AUG29",
      "AUG30 - SEP05",
      "SEP06 - SEP12",
      "SEP13 - SEP19",
      "SEP20 - SEP26",
      "SEP27 - OCT03",
      "OCT04 - OCT10",
      "OCT11 - OCT17",
      "OCT18 - OCT24",
      "OCT25 - OCT31",
      "NOV01 - NOV07",
      "NOV08 - NOV14",
      "NOV15 - NOV21",
      "NOV22 - NOV28",
      "NOV29 - DEC05",
      "DEC06 - DEC12",
      "DEC13 - DEC19",
      "DEC20 - DEC26",
      "DEC27 - JAN02",
      "JAN03 - JAN09",
      "JAN10 - JAN16",
      "JAN17 - JAN23",
      "JAN24 - JAN30",
      "JAN31 - FEB06",
      "FEB07 - FEB13",
      "FEB14 - FEB20",
      "FEB21 - FEB27",
      "FEB28 - MAR06",
      "MAR07 - MAR13",
      "MAR14 - MAR20",
      "MAR21 - MAR27",
      "MAR28 - APR03",
      "APR04 - APR10",
      "APR11 - APR17",
      "APR18 - APR24",
      "APR25 - MAY01",
      "MAY02 - MAY08",
      "MAY09 - MAY15",
      "MAY16 - MAY22",
      "MAY23 - MAY29",
      "MAY30 - JUN05",
      "JUN06 - JUN12",
      "JUN13 - JUN19",
      "JUN20 - JUN26",
      "JUN27 - JUL03",
      "JUL04 - JUL10",
      "JUL11 - JUL17",
      "JUL18 - JUL24",
      "JUL25 - JUL31",
      "AUG01 - AUG07",
      "AUG08 - AUG14",
      "AUG09 - AUG21",
      "AUG10 - AUG28",
      "AUG29 - SEP04",
      "SEP05 - SEP11",
      "SEP12 - SEP18",
      "SEP19 - SEP25",
      "SEP26 - OCT02",
      "OCT03 - OCT09",
      "OCT10 - OCT16",
      "OCT17 - OCT23",
      "OCT24 - OCT30",
      "OCT31 - NOV06",
      "NOV07 - NOV13",
      "NOV14 - NOV20",
      "NOV21 - NOV27",
      "NOV28 - DEC04",
      "DEC05 - DEC11",
      "DEC12 - DEC18",
      "DEC19 - DEC25",
      "DEC26 - JAN01",
    ];

    var annotations = [];
    for (var z = 0; z < weeks.length; z++) {
      if (z % 2 === 0 && z !== 0) {
        if (z !== weeks.length - 1) {
          annotations.push({
            x: z,
            y: avgs[z],
            xref: "x",
            yref: "y",
            text: avgsText[z],
            showarrow: true,
            font: {
              size: 18,
              color: "#ffffff",
            },
            align: "center",
            arrowhead: 2,
            arrowsize: 1,
            arrowwidth: 2,
            arrowcolor: "black",
            ax: -30,
            ay: -30,
            bordercolor: "black",
            borderwidth: 2,
            borderpad: 1,
            bgcolor: "black",
            opacity: 1,
          });
        }
      }
      if (z === weeks.length - 1) {
        annotations.push({
          x: z,
          y: avgs[avgs.length - 1],
          xref: "x",
          yref: "y",
          text: `${avgsText[avgs.length - 1]}*`,
          showarrow: true,
          font: {
            size: 18,
            color: "#ffffff",
          },
          align: "center",
          arrowhead: 2,
          arrowsize: 1,
          arrowwidth: 2,
          arrowcolor: "black",
          ax: -30,
          ay: -30,
          bordercolor: "black",
          borderwidth: 2,
          borderpad: 1,
          bgcolor: "black",
          opacity: 1,
        });
      }
    }

    for (var x = 0; x <= weeks.length; x++) {
      greenLimit.push(10);
      yellowLimit.push(90);
      redLimit.push(100);
    }
    var today = new Date();
    if (today.getHours() > 9) {
      var dd = today.getDate();

      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }

      if (mm < 10) {
        mm = "0" + mm;
      }
      var date = mm + "-" + dd + "-" + yyyy;
    } else if (today.getHours() === 9) {
      if (today.getMinutes() < 29) {
        var yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);

        dd = yesterday.getDate();
        mm = yesterday.getMonth() + 1;
        yyyy = yesterday.getFullYear();

        if (dd < 10) {
          dd = "0" + dd;
        }

        if (mm < 10) {
          mm = "0" + mm;
        }
        date = mm + "-" + dd + "-" + yyyy;
      } else {
        dd = today.getDate();

        mm = today.getMonth() + 1;
        yyyy = today.getFullYear();
        if (dd < 10) {
          dd = "0" + dd;
        }

        if (mm < 10) {
          mm = "0" + mm;
        }
        date = mm + "-" + dd + "-" + yyyy;
      }
    } else {
      yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);

      dd = yesterday.getDate();
      mm = yesterday.getMonth() + 1;
      yyyy = yesterday.getFullYear();

      if (dd < 10) {
        dd = "0" + dd;
      }

      if (mm < 10) {
        mm = "0" + mm;
      }
      date = mm + "-" + dd + "-" + yyyy;
    }
    return (
      <div className="my-5">
        <h4 style={{ marginBottom: "-82px", fontWeight: "bold" }}>
          Unadjusted Covid-19 infections, 7-day average
          <br />
          {/* MANUAL AQUÍ DIARIO */}
          <span style={{ fontWeight: "normal", fontSize: "16px" }}>
            * Last Update {date} at 9:30 AM
          </span>
        </h4>

        <Plot
          useResizeHandler
          className="weeklyAvgStyle"
          data={[
            {
              x: weeks,
              y: greenLimit,
              stackgroup: "one",
              showlegend: false,
              fillcolor: "fillcolor='rgba(0, 153, 51, 0.85)",
              line: { color: "green", width: 1 },
              hoverinfo: "skip",
            },
            {
              x: weeks,
              y: yellowLimit,
              stackgroup: "one",
              showlegend: false,
              fillcolor: "fillcolor='rgba(255, 255, 0, 0.85)",
              line: { color: "yellow", width: 1 },
              hoverinfo: "skip",
            },
            {
              x: weeks,
              y: redLimit,
              stackgroup: "one",
              fillcolor: "fillcolor='rgba(247, 75, 29,0.85)",
              line: { color: "#f74b1d", width: 1 },
              showlegend: false,
              hoverinfo: "skip",
            },
            {
              x: weeks,
              y: redLimit,
              stackgroup: "one",
              fillcolor: "fillcolor='rgba(235, 63, 27,0.85)",
              line: { color: "#eb3f1b", width: 1 },
              showlegend: false,
              hoverinfo: "skip",
            },
            {
              x: weeks,
              y: redLimit,
              stackgroup: "one",
              fillcolor: "fillcolor='rgba(225, 51, 24,0.85)",
              line: { color: "#e13318", width: 1 },
              showlegend: false,
              hoverinfo: "skip",
            },
            {
              x: weeks,
              y: redLimit,
              fillcolor: "fillcolor='rgba(215, 43, 23,0.85)",
              stackgroup: "one",
              line: { color: "#d72b17", width: 1 },
              showlegend: false,
              hoverinfo: "skip",
            },
            {
              x: weeks,
              y: redLimit,
              fillcolor: "fillcolor='rgba(206, 34, 20,0.85)",
              stackgroup: "one",
              line: { color: "#ce2214", width: 1 },
              showlegend: false,
              hoverinfo: "skip",
            },
            {
              x: weeks,
              y: redLimit,
              fillcolor: "fillcolor='rgba(197, 26, 19,0.85)",
              stackgroup: "one",
              line: { color: "#c51a13", width: 1 },
              showlegend: false,
              hoverinfo: "skip",
            },
            {
              x: weeks,
              fillcolor: "fillcolor='rgba(188, 20, 19,0.85)",
              y: redLimit,
              stackgroup: "one",
              line: { color: "#bc1413", width: 1 },
              showlegend: false,
              hoverinfo: "skip",
            },
            {
              x: weeks,
              fillcolor: "fillcolor='rgba(182, 13, 16,0.85)",
              y: redLimit,
              stackgroup: "one",
              line: { color: "#b60d10", width: 1 },
              showlegend: false,
              hoverinfo: "skip",
            },
            {
              x: weeks,
              fillcolor: "fillcolor='rgba(176, 6, 15,0.85)",
              y: redLimit,
              stackgroup: "one",
              line: { color: "#b0060f", width: 1 },
              showlegend: false,
              hoverinfo: "skip",
            },
            {
              x: weeks,
              fillcolor: "fillcolor='rgba(176, 6, 15,0.85)",
              y: redLimit,
              stackgroup: "one",
              line: { color: " #ac060f", width: 1 },
              showlegend: false,
              hoverinfo: "skip",
            },
            {
              x: weeks,
              fillcolor: "fillcolor='rgba(176, 6, 15,0.85)",
              y: redLimit,
              stackgroup: "one",
              line: { color: "#94050c", width: 1 },
              showlegend: false,
              hoverinfo: "skip",
            },
            {
              x: weeks,
              fillcolor: "fillcolor='rgba(165, 6, 15,0.85)",
              y: redLimit,
              stackgroup: "one",
              line: { color: "#94050c", width: 1 },
              showlegend: false,
              hoverinfo: "skip",
            },
            {
              x: weeks,
              fillcolor: "fillcolor='rgba(165, 6, 15,0.85)",
              y: redLimit,
              stackgroup: "one",
              line: { color: "#94050c", width: 1 },
              showlegend: false,
              hoverinfo: "skip",
            },
            // {
            //   x: weeks,
            //   fillcolor: "fillcolor='rgba(165, 6, 15,0.85)",
            //   y: redLimit,
            //   stackgroup: "one",
            //   line: { color: "#94050c", width: 1 },
            //   showlegend: false,
            //   hoverinfo: "skip",
            // },
            // {
            //   x: weeks,
            //   fillcolor: "fillcolor='rgba(165, 6, 15,0.85)",
            //   y: redLimit,
            //   stackgroup: "one",
            //   line: { color: "#94050c", width: 1 },
            //   showlegend: false,
            //   hoverinfo: "skip",
            // },
            {
              line: { color: "black", width: 4 },
              meta: { columnNames: { x: "A", y: "C" } },
              mode: "lines+markers+text",
              marker: {
                size: 10,
                maxdisplayed: weeks.length,
              },
              type: "scatter",
              xsrc: "AlejandroGalavizSalazar:0:4f5e9d",
              x: weeks,
              name: "<b>7 Day Average</b>",
              ysrc: "AlejandroGalavizSalazar:0:f0c424",
              y: avgs,
              textposition: "top-center",
              textfont: { size: 18 },
              showlegend: true,
              textinfo: "value",
              orientation: "v",
            },
          ]}
          layout={{
            autosize: true,
            margin: {
              l: 0,
              r: 0,
              b: 0,
              t: 140,
              pad: 4,
            },
            title: {
              // MANUAL AQUÍ DIARIO
              text: `<b style='font-size:32px;color:black'>Unadjusted Covid-19 infections, 7-day avg.</b><br><span style= 'font-weight: normal, font-size: 16px'>* Last Update ${date} at 9:30 AM</span>`,
            },
            xaxis: {
              type: "category",
              // MANUAL AQUÍ, DOMINGOS
              range: [-1, weeks.length],
              tickvals: weeks,
              ticktext: weeksText,
              nticks: weeks.length,
              tickangle: -90,
              title: {
                font: { size: 18, color: "black" },
                text: "<br><b> Epidemiological Week</b>",
              },
            },
            yaxis: {
              type: "linear",
              // MANUAL AQUÍ DIARIO
              range: [0, 1500],
              nticks: 28,
              title: {
                font: { size: 18, color: "black" },
                text: "<b>7 Day Average</b><br>",
              },
            },
            legend: {
              x: 0,
              y: 1.025,
              font: { size: 15, color: "black" },
              bgcolor: "transparent",
            },
            annotations,
            template: {
              data: {
                bar: [
                  {
                    type: "bar",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                table: [
                  {
                    type: "table",
                    cells: {
                      fill: { color: "#e8ebef" },
                      line: { color: "white" },
                    },
                    header: {
                      fill: { color: "#C8D4E3" },
                      line: { color: "white" },
                    },
                  },
                ],
                carpet: [
                  {
                    type: "carpet",
                    aaxis: {
                      gridcolor: "#C8D4E3",
                      linecolor: "#C8D4E3",
                      endlinecolor: "#2a3f5f",
                      minorgridcolor: "#C8D4E3",
                      startlinecolor: "#2a3f5f",
                    },
                    baxis: {
                      gridcolor: "#C8D4E3",
                      linecolor: "#C8D4E3",
                      endlinecolor: "#2a3f5f",
                      minorgridcolor: "#C8D4E3",
                      startlinecolor: "#2a3f5f",
                    },
                  },
                ],
                mesh3d: [
                  {
                    type: "mesh3d",
                    colorbar: { ticks: "", outlinewidth: 0 },
                  },
                ],
                contour: [
                  {
                    type: "contour",
                    colorbar: { ticks: "", outlinewidth: 0 },
                    autocolorscale: true,
                  },
                ],
                heatmap: [
                  {
                    type: "heatmap",
                    colorbar: { ticks: "", outlinewidth: 0 },
                    autocolorscale: true,
                  },
                ],
                scatter: [
                  {
                    type: "scatter",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                surface: [
                  {
                    type: "surface",
                    colorbar: { ticks: "", outlinewidth: 0 },
                  },
                ],
                heatmapgl: [
                  {
                    type: "heatmapgl",
                    colorbar: { ticks: "", outlinewidth: 0 },
                  },
                ],
                histogram: [
                  {
                    type: "histogram",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                parcoords: [
                  {
                    line: { colorbar: { ticks: "", outlinewidth: 0 } },
                    type: "parcoords",
                  },
                ],
                scatter3d: [
                  {
                    type: "scatter3d",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                scattergl: [
                  {
                    type: "scattergl",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                choropleth: [
                  {
                    type: "choropleth",
                    colorbar: { ticks: "", outlinewidth: 0 },
                  },
                ],
                scattergeo: [
                  {
                    type: "scattergeo",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                histogram2d: [
                  {
                    type: "histogram2d",
                    colorbar: { ticks: "", outlinewidth: 0 },
                    autocolorscale: true,
                  },
                ],
                scatterpolar: [
                  {
                    type: "scatterpolar",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                contourcarpet: [
                  {
                    type: "contourcarpet",
                    colorbar: { ticks: "", outlinewidth: 0 },
                  },
                ],
                scattercarpet: [
                  {
                    type: "scattercarpet",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                scattermapbox: [
                  {
                    type: "scattermapbox",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                scatterpolargl: [
                  {
                    type: "scatterpolargl",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                scatterternary: [
                  {
                    type: "scatterternary",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                histogram2dcontour: [
                  {
                    type: "histogram2dcontour",
                    colorbar: { ticks: "", outlinewidth: 0 },
                    autocolorscale: true,
                  },
                ],
              },
              layout: {
                geo: {
                  bgcolor: "white",
                  showland: true,
                  lakecolor: "white",
                  landcolor: "white",
                  showlakes: true,
                  subunitcolor: "#C8D4E3",
                },
                font: { color: "#2a3f5f" },
                polar: {
                  bgcolor: "white",
                  radialaxis: {
                    ticks: "",
                    gridcolor: "#e8ebef",
                    linecolor: "#e8ebef",
                  },
                  angularaxis: {
                    ticks: "",
                    gridcolor: "#e8ebef",
                    linecolor: "#e8ebef",
                  },
                },
                scene: {
                  xaxis: {
                    ticks: "",
                    gridcolor: "#DFE8F3",
                    gridwidth: 2,
                    linecolor: "#e8ebef",
                    zerolinecolor: "#e8ebef",
                    showbackground: true,
                    backgroundcolor: "white",
                  },
                  yaxis: {
                    ticks: "",
                    gridcolor: "#DFE8F3",
                    gridwidth: 2,
                    linecolor: "#e8ebef",
                    zerolinecolor: "#e8ebef",
                    showbackground: true,
                    backgroundcolor: "white",
                  },
                  zaxis: {
                    ticks: "",
                    gridcolor: "#DFE8F3",
                    gridwidth: 2,
                    linecolor: "#e8ebef",
                    zerolinecolor: "#e8ebef",
                    showbackground: true,
                    backgroundcolor: "white",
                  },
                },
                title: { x: 0.05 },
                xaxis: {
                  ticks: "",
                  gridcolor: "#e8ebef",
                  linecolor: "#e8ebef",
                  automargin: true,
                  zerolinecolor: "#e8ebef",
                  zerolinewidth: 2,
                },
                yaxis: {
                  ticks: "",
                  gridcolor: "#e8ebef",
                  linecolor: "#e8ebef",
                  automargin: true,
                  zerolinecolor: "#e8ebef",
                  zerolinewidth: 2,
                },
                ternary: {
                  aaxis: {
                    ticks: "",
                    gridcolor: "#DFE8F3",
                    linecolor: "#A2B1C6",
                  },
                  baxis: {
                    ticks: "",
                    gridcolor: "#DFE8F3",
                    linecolor: "#A2B1C6",
                  },
                  caxis: {
                    ticks: "",
                    gridcolor: "#DFE8F3",
                    linecolor: "#A2B1C6",
                  },
                  bgcolor: "white",
                },
                colorway: [
                  "#636efa",
                  "#EF553B",
                  "#00cc96",
                  "#ab63fa",
                  "#19d3f3",
                  "#e763fa",
                  "#fecb52",
                  "#ffa15a",
                  "#ff6692",
                  "#b6e880",
                ],
                hovermode: "closest",
                colorscale: {
                  diverging: [
                    [0, "#8e0152"],
                    [0.1, "#c51b7d"],
                    [0.2, "#de77ae"],
                    [0.3, "#f1b6da"],
                    [0.4, "#fde0ef"],
                    [0.5, "#f7f7f7"],
                    [0.6, "#e6f5d0"],
                    [0.7, "#b8e186"],
                    [0.8, "#7fbc41"],
                    [0.9, "#4d9221"],
                    [1, "#276419"],
                  ],
                  sequential: [
                    [0, "#0508b8"],
                    [0.0893854748603352, "#1910d8"],
                    [0.1787709497206704, "#3c19f0"],
                    [0.2681564245810056, "#6b1cfb"],
                    [0.3575418994413408, "#981cfd"],
                    [0.44692737430167595, "#bf1cfd"],
                    [0.5363128491620112, "#dd2bfd"],
                    [0.6256983240223464, "#f246fe"],
                    [0.7150837988826816, "#fc67fd"],
                    [0.8044692737430168, "#fe88fc"],
                    [0.8938547486033519, "#fea5fd"],
                    [0.9832402234636871, "#febefe"],
                    [1, "#fec3fe"],
                  ],
                  sequentialminus: [
                    [0, "#0508b8"],
                    [0.0893854748603352, "#1910d8"],
                    [0.1787709497206704, "#3c19f0"],
                    [0.2681564245810056, "#6b1cfb"],
                    [0.3575418994413408, "#981cfd"],
                    [0.44692737430167595, "#bf1cfd"],
                    [0.5363128491620112, "#dd2bfd"],
                    [0.6256983240223464, "#f246fe"],
                    [0.7150837988826816, "#fc67fd"],
                    [0.8044692737430168, "#fe88fc"],
                    [0.8938547486033519, "#fea5fd"],
                    [0.9832402234636871, "#febefe"],
                    [1, "#fec3fe"],
                  ],
                },
                plot_bgcolor: "white",
                paper_bgcolor: "white",
                shapedefaults: {
                  line: { width: 0 },
                  opacity: 0.85,
                  fillcolor: "#506784",
                },
                annotationdefaults: {
                  arrowhead: 0,
                  arrowcolor: "#506784",
                  arrowwidth: 1,
                },
              },
              themeRef: "PLOTLY_WHITE",
            },
            showlegend: true,
          }}
        />
        <p className="my-4">
          <span style={{ fontWeight: "bold", color: "green" }}>GREEN:</span>{" "}
          0-10 cases/100k people <br />
          <span style={{ fontWeight: "bold", color: "#c0c008" }}>YELLOW:</span>
          10-100 cases/100K people
          <br />
          <span style={{ fontWeight: "bold", color: "red" }}> RED:</span> 100+
          Cases/100k people
        </p>
      </div>
    );
  }
}
WeeklyAvg.propTypes = {
  getPimaData: PropTypes.func.isRequired,
  pimadatas: PropTypes.array.isRequired,
};
const mapStateToProps = (state) => ({
  pimadatas: state.pimadata.pimadatas,
});

export default connect(mapStateToProps, { getPimaData })(WeeklyAvg);
